export type Review = {
  id: string;
  author: string;
  city: string;
  eventType: "Mariage" | "Anniversaire" | "Entreprise" | "Soirée privée" | "Cérémonie";
  rating: 5 | 4;
  date: string; // ISO
  text: string;
  venue?: string;
  guests?: number;
};

export const REVIEWS: Review[] = [
  {
    id: "r1",
    author: "Camille & Antoine",
    city: "Gordes (84)",
    eventType: "Mariage",
    rating: 5,
    date: "2024-09-14",
    venue: "Bastide de Gordes",
    guests: 140,
    text: "Val a fait un travail exceptionnel. Pisté toute la soirée, lecture parfaite de l'ambiance, transitions impeccables. La piste n'a pas désempli jusqu'à 4 h du matin. Le matériel était discret, le son irréprochable même à l'extérieur. Mille mercis.",
  },
  {
    id: "r2",
    author: "Marie L.",
    city: "Avignon (84)",
    eventType: "Anniversaire",
    rating: 5,
    date: "2024-11-02",
    guests: 80,
    text: "Anniversaire 50 ans : Val a su mélanger les générations avec brio. Mes parents et mes ados ont dansé ensemble, c'était magique. Très pro dès le premier rendez-vous, ponctuel, équipement haut de gamme.",
  },
  {
    id: "r3",
    author: "Groupe Salinas SA",
    city: "Aix-en-Provence (13)",
    eventType: "Entreprise",
    rating: 5,
    date: "2024-12-13",
    venue: "Domaine de Saint-Estève",
    guests: 220,
    text: "Soirée de fin d'année réussie grâce à Val. Setup en amont, briefing avec notre DG, animation parfaitement calibrée. Facture conforme au devis, attestation SACEM fournie. Nous reprenons rendez-vous l'an prochain.",
  },
  {
    id: "r4",
    author: "Sophie & Julien",
    city: "Lourmarin (84)",
    eventType: "Mariage",
    rating: 5,
    date: "2024-06-22",
    venue: "Château de Lourmarin",
    guests: 110,
    text: "Cérémonie laïque + cocktail + soirée : un seul prestataire pour tout, un vrai luxe. Val a sonorisé la cérémonie en extérieur impeccablement, animé le cocktail tout en douceur puis embrasé la piste. Talentueux et bienveillant.",
  },
  {
    id: "r5",
    author: "Laurent M.",
    city: "Cavaillon (84)",
    eventType: "Anniversaire",
    rating: 5,
    date: "2024-03-09",
    guests: 60,
    text: "60 ans surprise pour mon père. Val s'est adapté à un répertoire 70s/80s très précis, a glissé quelques pépites italo-disco, ambiance de folie. La machine à fumée lourde sur la première danse, frissons garantis.",
  },
  {
    id: "r6",
    author: "Emilie & Tom",
    city: "Saint-Rémy-de-Provence (13)",
    eventType: "Mariage",
    rating: 5,
    date: "2024-08-31",
    venue: "Mas des Comtes de Provence",
    guests: 95,
    text: "On hésitait beaucoup entre plusieurs DJ, Val s'est démarqué dès le premier appel : à l'écoute, transparent sur les tarifs, force de proposition. Le jour J, tout était nickel. Nos invités en parlent encore.",
  },
  {
    id: "r7",
    author: "Cabinet Mercier & Associés",
    city: "Marseille (13)",
    eventType: "Entreprise",
    rating: 5,
    date: "2024-10-25",
    venue: "Villa Gaby",
    guests: 180,
    text: "Cocktail dînatoire + soirée dansante pour 15 ans du cabinet. Val a géré la sono des discours, le fond musical du dîner et a basculé en mode soirée sans heurts. Très professionnel, mise en place en amont rassurante.",
  },
  {
    id: "r8",
    author: "Inès & Karim",
    city: "Aix-en-Provence (13)",
    eventType: "Mariage",
    rating: 5,
    date: "2024-07-13",
    venue: "Domaine du Petit Sonnailler",
    guests: 160,
    text: "Mariage mixte franco-marocain : Val s'est documenté sur nos musiques traditionnelles, playlist d'entrée parfaite, puis fusion variété/hits/raï toute la nuit. Une vraie démarche pro et respectueuse.",
  },
  {
    id: "r9",
    author: "Hélène D.",
    city: "Carpentras (84)",
    eventType: "Cérémonie",
    rating: 5,
    date: "2024-05-18",
    guests: 70,
    text: "Cérémonie laïque en extérieur sous les platanes. Le son était parfait pour les discours, la musique d'entrée a fait pleurer toute l'assemblée. Val a discrètement coordonné avec l'officiant et le photographe.",
  },
  {
    id: "r10",
    author: "Pierre & Vanessa",
    city: "Isle-sur-la-Sorgue (84)",
    eventType: "Mariage",
    rating: 5,
    date: "2024-09-07",
    venue: "Domaine de Fontenille",
    guests: 130,
    text: "Devis ultra clair, contrat carré, présence rassurante. Val a su gérer un imprévu météo (passage rapide en intérieur) sans aucun stress pour nous. La soirée a été un feu d'artifice.",
  },
  {
    id: "r11",
    author: "Comité d'entreprise EDF Sud",
    city: "Orange (84)",
    eventType: "Entreprise",
    rating: 5,
    date: "2024-12-06",
    guests: 350,
    text: "Arbre de Noël : animation famille en journée, puis soirée adultes. Val a tenu les deux temps avec une énergie incroyable. Matériel pro, facturation impeccable, on recommande sans réserve.",
  },
  {
    id: "r12",
    author: "Jessica B.",
    city: "Pertuis (84)",
    eventType: "Anniversaire",
    rating: 5,
    date: "2024-04-20",
    guests: 45,
    text: "30 ans entre amis dans une bastide. Val a transformé une simple terrasse en vraie piste de danse avec ses lyres et lasers. Set hip-hop / électro / années 2000 nickel.",
  },
  {
    id: "r13",
    author: "Léa & Mathieu",
    city: "Bonnieux (84)",
    eventType: "Mariage",
    rating: 5,
    date: "2024-08-17",
    venue: "Bastide Saint-Joseph",
    guests: 85,
    text: "Petit mariage intime, on cherchait quelqu'un qui sache animer sans en faire trop. Val a parfaitement saisi notre demande : discret au cocktail, présent et fédérateur en soirée. Bravo.",
  },
  {
    id: "r14",
    author: "Nicolas P.",
    city: "Apt (84)",
    eventType: "Soirée privée",
    rating: 5,
    date: "2024-02-10",
    guests: 50,
    text: "Soirée à thème années 80 chez moi. Val est venu avec une déco lumineuse en plus du DJ set, ambiance immédiate. Vraiment top.",
  },
  {
    id: "r15",
    author: "Claire & Romain",
    city: "Ménerbes (84)",
    eventType: "Mariage",
    rating: 5,
    date: "2024-06-08",
    venue: "Domaine de la Citadelle",
    guests: 120,
    text: "Coup de cœur pour le contact dès le premier mail. Val a même proposé une visite du lieu en amont pour caler la régie. Le résultat : une soirée fluide, sans le moindre temps mort.",
  },
  {
    id: "r16",
    author: "Christine R.",
    city: "Salon-de-Provence (13)",
    eventType: "Anniversaire",
    rating: 5,
    date: "2024-11-23",
    guests: 90,
    text: "40 ans d'amitié fêtés en grand. Val a réussi à mixer les goûts très éclectiques de notre bande. Rapport qualité-prix excellent, matériel impeccable.",
  },
  {
    id: "r17",
    author: "Studio Helios SARL",
    city: "Avignon (84)",
    eventType: "Entreprise",
    rating: 5,
    date: "2025-01-25",
    venue: "Hôtel de l'Atelier",
    guests: 60,
    text: "Inauguration de nos nouveaux locaux. Val a fourni sono + animation cocktail pendant 4 h. Très professionnel, devis ultra transparent, attestation SACEM remise sans qu'on ait à demander.",
  },
  {
    id: "r18",
    author: "Amélie & Yann",
    city: "Roussillon (84)",
    eventType: "Mariage",
    rating: 5,
    date: "2024-09-21",
    venue: "Mas de la Beaume",
    guests: 75,
    text: "Marriage en petit comité, ambiance bohème. Val a apporté juste ce qu'il fallait : du goût, du rythme, et zéro folklore kitsch. Parfait pour nous.",
  },
];

export const AVG_RATING =
  REVIEWS.reduce((s, r) => s + r.rating, 0) / REVIEWS.length;
export const REVIEW_COUNT = REVIEWS.length;
